var Sentiment;
(function (Sentiment) {
  Sentiment["NEGATIVE"] = "negative";
  Sentiment["NEUTRAL"] = "neutral";
  Sentiment["POSITIVE"] = "positive";
  Sentiment["WARNING"] = "warning";
  Sentiment["PENDING"] = "pending";
  /**
   * @deprecated
   */
  Sentiment["INFO"] = "info";
  /**
   * @deprecated
   */
  Sentiment["ERROR"] = "error";
  /**
   * @deprecated
   */
  Sentiment["SUCCESS"] = "success";
})(Sentiment || (Sentiment = {}));

export { Sentiment };
//# sourceMappingURL=sentiment.mjs.map
